import { IApplicationState } from '../../types/redux';

export const selectCianHost = (state: IApplicationState) => state.config.cianHost;
